import Cookies from 'js-cookie';
import { useState } from 'react';

import { isJordanWinery } from 'common/helpers/featureFlags';
// eslint-disable-next-line import/no-cycle
import LoginModal from 'profile/login/LoginModal';

const LoginToPurchase = (props) => {
  const [modal, setModal] = useState(null);

  const handleLogin = () => {
    setModal('Login');
  };

  const { reservationType } = props;
  if (Cookies.get('customerToken')) {
    return (
      <div className="c7-reservation-type__login-message">
        <LoggedInMessage reservationType={reservationType} />
      </div>
    );
  }
  return (
    <>
      <div className="c7-reservation-type__login-message">
        <NotLoggedInMessage reservationType={reservationType} />
        {!isJordanWinery() && (
          <button type="button" className="c7-button" onClick={handleLogin}>
            Login
          </button>
        )}
      </div>
      <LoginModal modal={modal} setModal={setModal} />
    </>
  );
};

const NotLoggedInMessage = (props) => {
  const { reservationType } = props;
  switch (reservationType.security.availableTo) {
    case 'Club': {
      return (
        <p>
          This reservation type is for club members only. Please login to
          purchase.
        </p>
      );
    }
    case 'Tag': {
      return (
        <p>
          This reservation type is for select customers only. Please login to
          purchase.
        </p>
      );
    }
    case 'Loyalty Tier': {
      return (
        <p>
          This reservation type is for loyalty members only. Please login to
          purchase.
        </p>
      );
    }
    default: {
      return (
        <p>This is a secure reservation type. Please login to purchase.</p>
      );
    }
  }
};

const LoggedInMessage = (props) => {
  const { reservationType } = props;
  switch (reservationType.security.availableTo) {
    case 'Club': {
      return (
        <p>
          This reservation type is for customers who are club members. Please
          signup to purchase.
        </p>
      );
    }
    case 'Tag': {
      return <p>This reservation type is for select customers only.</p>;
    }
    case 'Loyalty Tier': {
      return (
        <p>This reservation type is for certain levels of Loyalty only.</p>
      );
    }
    default: {
      return <p>This is a secure reservationType</p>;
    }
  }
};

export default LoginToPurchase;
